import classNames from 'classnames'

import { RadioCardGroupOption } from './L3OnboardingRadioCardGroup.Option'

export type RadioCardItem<ItemValue extends string> = {
  /**
   * Card label.
   */
  label: string
  /**
   * Card value.
   */
  value: ItemValue
}

export interface L3OnboardingRadioCardGroupProps<ItemValue extends string> {
  /**
   * Disabled?
   */
  disabled?: boolean
  /**
   * Warning state?
   */
  warning?: boolean
  /**
   * Custom style.
   */
  className?: string
  /**
   * Group label.
   */
  groupLabel?: string
  /**
   * Group label custom style.
   */
  groupLabelClassName?: string
  /**
   * Field name.
   */
  name: string
  /**
   * Options.
   */
  options: RadioCardItem<ItemValue>[]
}

/**
 * Circle L3 Onboarding Radio Card Group.
 */
export const L3OnboardingRadioCardGroup = <ItemValue extends string>({
  groupLabel,
  groupLabelClassName,
  disabled = false,
  warning = false,
  name,
  options,
  className,
}: L3OnboardingRadioCardGroupProps<ItemValue>) => {
  return (
    <fieldset
      className="rounded-sm focus:focus-ring"
      data-field-group="true"
      tabIndex={-1}
    >
      {groupLabel && (
        <legend
          className={classNames(
            'min-h-6 text-sm text-neutral font-circular-medium',
            groupLabelClassName,
          )}
        >
          {groupLabel}
        </legend>
      )}
      <div className={classNames('flex gap-6 mt-1', className)} tabIndex={-1}>
        {options.map(({ label, value }, index) => (
          <RadioCardGroupOption
            key={index}
            className="w-full rounded-sm focus-within:focus-ring"
            disabled={disabled}
            label={label}
            name={name}
            value={value}
            warning={warning}
          />
        ))}
      </div>
    </fieldset>
  )
}
